import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEventHandler, ReactNode } from "react";
import Modal from "react-modal";
import { LOW_GRAY, NEAR_WHITE } from "../../config";
import { StyledHrGlobal } from "../../styles/global";
import { LoadingIndicator } from "../LoadingIndicator";
import { Body, CloseIcon, Content, Footer, Header, ModalContainer } from "./styled";

interface GenericModalProps {
  isOpen: boolean;
  onClose: (event: React.MouseEvent | React.KeyboardEvent) => void;
  header: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
  width?: string;
  isLoading?: boolean;
  shouldRender?: boolean;
  handleSubmit?: FormEventHandler<HTMLFormElement>;
  formId?: string;
  customClassName?: string;
  showDivider?: boolean;
}

export const GenericModal: React.FC<GenericModalProps> = ({
  isOpen,
  onClose,
  header,
  content,
  footer,
  width,
  isLoading,
  shouldRender = true,
  handleSubmit,
  formId,
  customClassName,
  showDivider,
}: GenericModalProps) => (
  // @ts-ignore
  <Modal
    isOpen={isOpen}
    closeTimeoutMS={200}
    onRequestClose={(event) => onClose(event)}
    style={{
      overlay: {
        zIndex: 5,
        transition: "0.2s ease-in-out",
        background: "#191919B3",
      },
    }}
    className="generic-modal"
    testId="generic-modal"
  >
    {isLoading ? <LoadingIndicator /> : null}
    {shouldRender && !isLoading ? (
      <ModalContainer
        width={width}
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={customClassName}
      >
        <Header data-testid="generic-modal-header">
          <>
            {header}
            <CloseIcon onClick={(event) => onClose(event)} id="close-icon">
              <FontAwesomeIcon style={{ fontSize: "24px" }} color={NEAR_WHITE} icon={faPlus} />
            </CloseIcon>
          </>
        </Header>
        {showDivider && <StyledHrGlobal customColor={LOW_GRAY} />}
        <form id={formId} onSubmit={handleSubmit}>
          <Body>
            <Content data-testid="generic-modal-content" hasFooter={Boolean(footer)}>
              {content}
            </Content>
          </Body>
        </form>

        {footer ? <Footer data-testid="generic-modal-footer">{footer}</Footer> : null}
      </ModalContainer>
    ) : null}
  </Modal>
);
